import   React      ,
       { useState   ,} from "react"
import { TextField  , 
         Typography ,
         Box        ,
         Grid       ,
         Container  ,
         Button     ,} from "@mui/material"
import   axios         from 'axios'

function PokemonGetImg() {
  const [value         , setValue         ] = useState() // 答えのテキストボックスに入力している値
  const [pokemonname   , setPokemonName   ] = useState() // ポケモンの名前
  const [pokemonImage  , setPokemonImage  ] = useState() // ポケモン画像表示
  const [pokemonhight  , setPokemonHight  ] = useState() // ポケモンの高さ
  const [pokemonweight , setPokemonWeight ] = useState() // ポケモンの重さ
  const [pokemontext   , setPokemonText   ] = useState() // ポケモンの説明文
  const [pokemongenus  , setPokemonGenus  ] = useState() // ポケモンの分類


  // テキストボックスの内容
  const handleChange = (event) => {
    // 入力された値が数字でない場合は削除します
    const inputValue = event.target.value.replace(/[^0-9]/g, '')
    setValue(inputValue)
    console.log(value)
  }

  // ポケモンAPIを呼び出す
  const fetchPokemonImages = async () => {
    // ポケモンAPIを呼び出す
    const response = await axios.get("https://pokeapi.co/api/v2/pokemon/" + value)
    // ポケモンの画像を取得
    setPokemonImage(response.data.sprites.front_default)

    // 高さを取得
    setPokemonHight((response.data.height / 10).toFixed(1))

    // 重さを取得
    setPokemonWeight((response.data.weight / 10).toFixed(1))

    // 分類、説明文を取得するための準備
    const speciesUrl = response.data.species.url
    const speciesResponse = await axios.get(speciesUrl)

    // 分類を取得
    const genera = speciesResponse.data.genera
    const genus = genera.find((v) => v.language.name == "ja-Hrkt")
    setPokemonGenus(genus.genus)

    // ポケモンの名前を取得
    const japaneseName = speciesResponse.data.names.find(name => name.language.name === "ja").name
    setPokemonName(japaneseName)

    // 説明文取得
    const flavorTextEntries = speciesResponse.data.flavor_text_entries
    console.log(flavorTextEntries)
    let flavorText = flavorTextEntries.filter(function(v) {
      return (v.language.name == "ja-Hrkt") && (v.version.name == "sword")
    })
    if (flavorText.length == 0) {
      // バージョンをYで取得し直す.
      flavorText = flavorTextEntries.filter(function(v) {
        return (v.language.name == "ja-Hrkt") && (v.version.name == "y")
      })
    }
    if (flavorText.length == 0) {
      // バージョンをサンで取得し直す.
      flavorText = flavorTextEntries.filter(function(v) {
        return (v.language.name == "ja-Hrkt") && (v.version.name == "sun")
      })
    }
    if (flavorText.length == 0) {
      // バージョンをウルトラサンで取得し直す.
      flavorText = flavorTextEntries.filter(function(v) {
        return (v.language.name == "ja-Hrkt") && (v.version.name == "ultra-sun")
      })
    }
    let cleanedText = flavorText[0].flavor_text
    console.log(cleanedText)
    // 説明文が見つからないとき
    if (cleanedText.length < 0){
      console.log(cleanedText)
      cleanedText = "ポケモンのデータがありませんでした。"
    }
    setPokemonText(cleanedText)
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ flexGrow: 1,
                  bgcolor: '#f5f5f5' }}>
          {/* テキスト表示領域 */}
          <Grid container spacing={2}>
            <Grid item xs={12} align="center">
              <Typography>
                ポケモン画像を取得
              </Typography>
            </Grid>
            <Grid item xs={12} align="center">
              <Typography>
                数字を入力
              </Typography>
            </Grid>
            <Grid item xs={6} align="right">
              <TextField 
                value={value}
                onChange={handleChange}>
              </TextField>
            </Grid>
            <Grid item xs={6} align="left">
              <Button variant='contained'
                onClick={fetchPokemonImages}>
                ポケモンを取得
              </Button>
            </Grid>
            {/* ポケモン表示 */}
            <Grid item xs={12} align="center">
              <img
                src    = {pokemonImage}
                width  = "150px"
                height = "150px"/>
            </Grid>
            {/* ポケモンの名前 */}
            <Grid item xs={12} align="center">
              <Typography>
                ポケモンの名前：{pokemonname} </Typography>
            </Grid>
            {/* ポケモンのおもさ */}
            <Grid item xs={12} align="center">
              <Typography>
                ポケモンのおもさ：{pokemonweight} kg</Typography>
            </Grid>
            {/* ポケモンのたかさ */}
            <Grid item xs={12} align="center">
              <Typography>
                ポケモンのたかさ：{pokemonhight} m</Typography>
            </Grid>
            {/* ポケモンの分類 */}
            <Grid item xs={12} align="center">
              <Typography>
                ポケモンの分類：{pokemongenus} </Typography>
            </Grid>
            {/* ポケモンの説明文 */}
            <Grid item xs={12} align="center">
              <Typography>
                ポケモンの説明文：{pokemontext} </Typography>
            </Grid>            
          </Grid>
      </Box>
    </Container>
  )
}

export default PokemonGetImg